module.exports = __webpack_public_path__ + "img/MLOGO_red_5rgb.c372d395.svg";